export function isStrongPassword(input) {
  const inputString = String(input);
  const regex = new RegExp(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,15}$/
  );
  if (!inputString) return false;
  return regex.test(inputString);
}
